"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
class User {
}
exports.User = User;
//# sourceMappingURL=User.js.map